/**
 * SummaryStrip — the conditional gold banner above the list, shown ONLY when ≥1 reference is
 * Ready·Locked (design-spec/02 "Summary strip"). Gold-tint fill, gold-text label (the sanctioned
 * text-on-tint pairing), clock glyph. Copy: "1 reference ready to unlock" (04-copy).
 */
interface SummaryStripProps {
  count: number;
}

export function SummaryStrip({ count }: SummaryStripProps) {
  if (count < 1) return null;
  const label =
    count === 1 ? '1 reference ready to unlock' : `${count} references ready to unlock`;
  return (
    <div
      role="status"
      className="mb-3.5 flex items-center gap-2.5 rounded-[15px] border border-[rgba(200,137,42,0.32)] bg-gold-tint px-3.5 py-2.5 font-body text-[13px] font-medium text-gold-text"
    >
      <svg viewBox="0 0 24 24" fill="none" width={17} height={17} aria-hidden="true" className="flex-none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
        <path d="M12 8v4l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      {label}
    </div>
  );
}
